module.exports = __webpack_public_path__ + "static/media/3.fbeeb327.jpg";